import { makeAutoObservable, reaction } from 'mobx'
import { ServerError } from '../models/serverError'
import type { MotdDto } from '../models/motd'

export default class CommonStore {
  error: ServerError | null = null
  token: string | null = window.localStorage.getItem('jwt')
  appLoaded = false

  currentMotd: MotdDto | null = null
  loadingMotd = false

  featureFlags: Record<string, boolean> = {}
  loadingFeatureFlags = false

  constructor () {
    makeAutoObservable(this)
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem('jwt', token)
        } else {
          window.localStorage.removeItem('jwt')
        }
      }
    )
  }

  setServerError = (error: ServerError) => {
    this.error = error
  }

  setToken = (token: string | null) => {
    this.token = token
  }

  setAppLoaded = () => {
    this.appLoaded = true
  }

  loadMotd = async () => {
    this.loadingMotd = true
    try {
      // Dynamic import avoids a circular dependency:
      // commonStore -> agent -> store -> commonStore (module init crash).
      const { default: agent } = await import('../api/agent')
      this.currentMotd = await agent.Motd.get()
    } catch {
      this.currentMotd = null
    } finally {
      this.loadingMotd = false
    }
  }

  setCurrentMotd = (motd: MotdDto | null) => {
    this.currentMotd = motd
  }

  loadFeatureFlags = async () => {
    this.loadingFeatureFlags = true
    try {
      // Same dynamic import pattern as loadMotd to avoid circular dep.
      const { default: agent } = await import('../api/agent')
      const flags = await agent.FeatureFlags.list()
      const map: Record<string, boolean> = {}
      for (const f of flags) map[f.key] = f.isEnabled
      this.featureFlags = map
    } catch {
      this.featureFlags = {}
    } finally {
      this.loadingFeatureFlags = false
    }
  }
}
